import { Link } from "react-router-dom";
import { Footer7 } from "@/components/ui/footer-7";
import { FaLinkedin } from "react-icons/fa";
import xeniraLogo from "@/assets/xenira-logo.png";
import { BUILD_ID } from "@/hooks/useScrollWatchdog";

const Footer = () => {
  const xeniraSections = [
    {
      title: "Technology",
      links: [
        { name: "Lipid Delivery", href: "/#technology" },
        { name: "Development", href: "/development-process" },
        { name: "Manufacturing", href: "/manufacturing" },
        { name: "Innovation", href: "/#capabilities" },
      ],
    },
    {
      title: "Company",
      links: [
        { name: "About", href: "/about" },
        { name: "Contact", href: "/#contact-info" },
      ],
    },
    {
      title: "Partnership",
      links: [
        { name: "Partner With Us", href: "/#contact-info" },
        { name: "Technology Transfer", href: "/#contact-info" },
        { name: "Licensing", href: "/#contact-info" },
        { name: "Collaboration", href: "/#contact-info" },
      ],
    },
  ];

  const xeniraSocialLinks = [
    {
      icon: <FaLinkedin className="size-5" />,
      href: "https://www.linkedin.com/company/xenira-pharmaceuticals/",
      label: "LinkedIn"
    }
  ];

  const handleCookieSettings = () => {
    window.dispatchEvent(new CustomEvent('open-cookie-preferences'));
  };

  const xeniraLegalLinks = [
    { name: "Privacy Policy", href: "/privacy-policy" },
    { name: "Terms & Conditions", href: "/terms" },
    { name: "Cookie Settings", href: "#", onClick: handleCookieSettings },
  ];

  return (
    <footer id="footer">
      <Footer7
        logo={{
          url: "/",
          src: xeniraLogo,
          alt: "XENIRA Logo",
          title: "XENIRA",
        }}
        sections={xeniraSections}
        description="Leading pharmaceutical innovation through advanced lipid-based drug delivery solutions for enhanced therapeutic efficacy."
        copyright={`© 2025 Xenira Pharmaceuticals. All rights reserved. | Build: ${BUILD_ID}`}
        legalLinks={xeniraLegalLinks}
        socialLinks={xeniraSocialLinks}
      />
    </footer>
  );
};

export default Footer;
